/** sessionStorage key for raw split invite token before server reservation */
export const PENDING_SPLIT_INVITE_TOKEN_KEY = 'songplace.pendingSplitInviteToken';

/** sessionStorage flag: Auth0 user has a reserved server-side claim awaiting finalize */
export const PENDING_SPLIT_INVITE_CLAIM_KEY = 'songplace.pendingSplitInviteClaim';

/** Max plausible raw invite token length (base64url) */
export const MAX_SPLIT_INVITE_TOKEN_LENGTH = 128;

export const isPlausibleSplitInviteToken = (token: string | null | undefined): boolean => {
  if (!token || typeof token !== 'string') return false;
  const trimmed = token.trim();
  if (trimmed.length < 20 || trimmed.length > MAX_SPLIT_INVITE_TOKEN_LENGTH) return false;
  return /^[A-Za-z0-9_-]+$/.test(trimmed);
};
